module.exports = __webpack_public_path__ + "img/626.Plates.678d1616.svg";